/*! Built for Denver James. */
import Cart from "cart-store";

import { formatMoney } from "utils";

class CartFreeShippingUpsell extends HTMLElement {
    #boundAdd;
    constructor() {
        super();
        this.#boundAdd = this.#addToCart.bind(this);
    }
    connectedCallback() {
        this.amountElement = this.querySelector("amount-left");
        this.moneyValueElement = this.amountElement ? this.amountElement.querySelector("money-value") : null;
        this.trigger = this.querySelector("button");
        this.stagedAction = this.querySelector("staged-action");
        this.imageElement = this.querySelector("[data-upsell-image]");
        this.linkElement = this.querySelector("[data-upsell-link]");
        this.minimumValue = Number(this.getAttribute("minimum-value"));
        this.maxGap = Number(this.getAttribute("max-gap"));
        const candidatesScript = this.querySelector("[data-upsell-candidates]");
        try {
            this.candidates = candidatesScript ? JSON.parse(candidatesScript.textContent) : [];
        } catch (error) {
            this.candidates = [];
        }
        this.activeVariantId = null;
        this.#evaluate(Cart.getState().cart);
        this.unsubscribe = Cart.subscribe((state => {
            this.#evaluate(state.cart);
        }));
        if (this.trigger) {
            this.trigger.addEventListener("click", this.#boundAdd);
        }
    }
    disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
        if (this.trigger) this.trigger.removeEventListener("click", this.#boundAdd);
    }
    #evaluate(cart) {
        if (!cart || !this.candidates || !this.candidates.length) {
            this.activeVariantId = null;
            this.setAttribute("hidden", "");
            return;
        }
        const value = cart.total_price || 0;
        this.setAttribute("value", value);
        const moneyLeft = Math.max(this.minimumValue - value, 0);
        const cartVariantIds = new Set((cart.items || []).map((item => String(item.variant_id))));
        const candidate = this.candidates
            .filter((c => !cartVariantIds.has(String(c.variantId))))
            .filter((c => c.price >= moneyLeft))
            .sort(((a, b) => a.price - b.price))[0];
        const shouldShow = moneyLeft > 0 && moneyLeft <= this.maxGap && !!candidate;
        if (shouldShow) {
            this.activeVariantId = candidate.variantId;
            if (this.moneyValueElement) {
                this.moneyValueElement.innerHTML = formatMoney(moneyLeft, window.theme.money_format).replace(/[.,]00$/, "");
            }
            if (this.imageElement && candidate.image) {
                this.imageElement.src = candidate.image;
                this.imageElement.alt = candidate.title || "";
            }
            if (this.linkElement && candidate.url) {
                this.linkElement.href = candidate.url;
            }
            this.removeAttribute("hidden");
        } else {
            this.activeVariantId = null;
            this.setAttribute("hidden", "");
        }
    }
    async #addToCart(e) {
        e.preventDefault();
        if (!this.activeVariantId) return;
        try {
            if (this.stagedAction) await this.stagedAction.setState("DOING");
            await Cart.add({
                id: this.activeVariantId,
                quantity: 1
            });
            if (this.stagedAction) await this.stagedAction.setState("DONE");
        } catch (error) {
            console.log(error);
            if (this.stagedAction) await this.stagedAction.setState("IDLE");
        }
    }
}

customElements.define("cart-free-shipping-upsell", CartFreeShippingUpsell);
